/**
 * カスタムカーソル
 * 小ドット（即時追従）＋ リング（遅延追従）
 * リンク・ボタンホバー時にリングが拡大
 */
const cursorModule = {
  init() {
    // タッチデバイスはスキップ
    if (window.matchMedia('(pointer: coarse)').matches) return;

    const dot  = document.querySelector('.c-cursor__dot');
    const ring = document.querySelector('.c-cursor__ring');
    if (!dot || !ring) return;

    // ネイティブカーソルを非表示
    document.documentElement.classList.add('has-custom-cursor');

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let ringX  = mouseX;
    let ringY  = mouseY;

    // xPercent/yPercent で中心合わせ（CSS の translate(-50%,-50%) の代わり）
    gsap.set(dot,  { xPercent: -50, yPercent: -50 });
    gsap.set(ring, { xPercent: -50, yPercent: -50 });

    // ドットはマウス座標に即座に追従
    window.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      gsap.set(dot, { x: mouseX, y: mouseY });
    });

    // リングはGSAPで慣性追従
    gsap.ticker.add(() => {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      gsap.set(ring, { x: ringX, y: ringY });
    });

    // ホバー対象
    const hoverTargets = 'a, button, [role="button"], input, label, select, textarea';

    document.addEventListener('mouseover', (e) => {
      if (e.target.closest(hoverTargets)) {
        ring.classList.add('is-hover');
      }
    });
    document.addEventListener('mouseout', (e) => {
      if (e.target.closest(hoverTargets)) {
        ring.classList.remove('is-hover');
      }
    });

    // クリック時に縮む演出
    document.addEventListener('mousedown', () => {
      dot.classList.add('is-click');
      ring.classList.add('is-click');
    });
    document.addEventListener('mouseup', () => {
      dot.classList.remove('is-click');
      ring.classList.remove('is-click');
    });

    // ウィンドウ外に出たとき非表示
    document.addEventListener('mouseleave', () => {
      dot.classList.add('is-hidden');
      ring.classList.add('is-hidden');
    });
    document.addEventListener('mouseenter', () => {
      dot.classList.remove('is-hidden');
      ring.classList.remove('is-hidden');
    });
  },
};

export default cursorModule;
